import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { EventBusyOutlined, MonetizationOn, RecentActors } from '@mui/icons-material';
import { FinanceSummaryCard, Money } from '@uplift/ui-v2';
import { ProviderFinancePeriod } from '@uplift/api';

export type SummaryCardsProps = Pick<ProviderFinancePeriod, 'paid' | 'sessions' | 'lateFees'> & { msoPayout?: boolean };

const useStyles = makeStyles()((theme) => ({
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(1),
    borderRadius: theme.spacing(0.5),
    color: theme.palette.common.white
  },
  secondaryDark: {
    background: theme.palette.secondary.dark,
  },
  secondary: {
    background: theme.palette.secondary.main,
  },
  secondaryLight: {
    background: theme.palette.secondary.light,
  },
}));

export const SummaryCards: React.VFC<SummaryCardsProps> = ({ paid, sessions, lateFees, msoPayout = false }) => {
  const { classes } = useStyles();

  return (
    <Box display="flex" alignItems="center" gap="1rem">
      <FinanceSummaryCard
        label={msoPayout ? 'billings' : 'payout'}
        value={<Money value={paid} currency="$" />}
        icon={<MonetizationOn />}
        iconContainerClassName={classes.secondaryDark}
      />
      <FinanceSummaryCard
        label="sessions"
        value={sessions}
        icon={<RecentActors />}
        iconContainerClassName={classes.secondary}
      />
      {!msoPayout && (
        <FinanceSummaryCard
          label="late fees"
          value={lateFees}
          icon={<EventBusyOutlined />}
          iconContainerClassName={classes.secondaryLight}
        />
      )}
      {/* {summaryCards.map(({ value, label, icon, iconContainerClassName }, index) => (
        <FinanceSummaryCard
          key={index}
          value={value}
          label={label}
          icon={icon}
          iconContainerClassName={iconContainerClassName}
        />
      ))} */}
    </Box>
  );
};
